import {BusinessPageContent} from '@common/business/business-page-content';

// some settings pages persist lists as an object keyed by index instead of
// an array (eg. {"1": {...}, "0": {...}}) if keys ever go out of order,
// which breaks useFieldArray and any .map()/.length usage. Coerce back to
// an array so existing data still displays and self-heals on the next save.
function toArray<T>(value: T[] | Record<string, T> | undefined | null): T[] {
  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value === 'object') {
    return Object.values(value);
  }
  return [];
}

const defaultLogos: BusinessPageContent['logos'] = Array.from(
  {length: 10},
  (_, i) => ({image: `images/homepage/logos_${i + 1}.png`}),
);

const defaultWorkflowFeatures: BusinessPageContent['workflowFeatures'] = [
  {
    image: 'images/homepage/space_4.png',
    title: 'Teams & access levels',
    description:
      'Organize your employees in teams and set group permissions or give individual access levels, where needed.',
  },
  {
    image: 'images/homepage/space_3.png',
    title: 'Shared folders',
    description:
      'Optimize your teams’ workflow with organized shared folders to control data access in and outside the company.',
  },
  {
    image: 'images/homepage/space_2.png',
    title: 'Comments to files & folders',
    description:
      'Take the opportunity to comment on files to ease user collaboration and skip using unsecured chat platforms.',
  },
  {
    image: 'images/homepage/space_1.png',
    title: 'Activity monitoring',
    description:
      'Have all of your account activity recorded in detailed logs and access any previous versions of your files.',
  },
];

const defaultCuttingEdgeFeatures: BusinessPageContent['cuttingEdgeFeatures'] = [
  {
    image: 'images/homepage/key_img_1.png',
    title: 'Increased storage space',
    description: 'Develop yo your ideas on your PC without taking actual with poloud Drive.',
  },
  {
    image: 'images/homepage/key_img_2.png',
    title: 'Unbeatable security',
    description: 'Encrypt your private firies without giving access to anyone else with Ckud Encryptin',
  },
  {
    image: 'images/homepage/key_img_3.png',
    title: 'Enhanced search',
    description: 'Search the contents of your documents and find files the way you romarribar chain.',
  },
  {
    image: 'images/homepage/key_img_4.png',
    title: 'Scalable System',
    description:
      'Have all of your account activity recorded in detailed logs and access any previous versions of your files.',
  },
];

// every field is carried through unedited so a settings page editing one
// slice of businessPage content doesn't wipe out the fields owned by the
// other settings pages (mirrors pricing-page-appearance-defaults.ts).
export function getBusinessPageAppearanceDefaults(
  appearance: Partial<BusinessPageContent>,
): BusinessPageContent {
  return {
    bannerHeading:
      appearance.bannerHeading ?? 'Get <span>Onetime</span> for your Business',
    bannerSubtext:
      appearance.bannerSubtext ??
      'The complete, secure platform to store, sync and collaborate on your business files with your colleagues',
    bannerImage: appearance.bannerImage ?? 'images/homepage/businees_img.png',

    pricingProductId: appearance.pricingProductId ?? '',

    logosHeading: appearance.logosHeading ?? 'Featured in:',
    logos: toArray(appearance.logos).length ? toArray(appearance.logos) : defaultLogos,

    workflowHeading:
      appearance.workflowHeading ??
      'Easy-to-use tools designed to help you control and optimize your workflow',
    workflowImage: appearance.workflowImage ?? 'images/homepage/flow_img.png',
    workflowFeatures: toArray(appearance.workflowFeatures).length
      ? toArray(appearance.workflowFeatures)
      : defaultWorkflowFeatures,

    testimonialQuoteLine1:
      appearance.testimonialQuoteLine1 ??
      '"Easy to use, quite easy to configure, great to use on several systems.',
    testimonialQuoteLine2:
      appearance.testimonialQuoteLine2 ??
      'Having tried several cloud systems before I found pCloud very easy and comfortable to use and will use it for the time to come."',
    testimonialAuthor: appearance.testimonialAuthor ?? 'Thomas Duntze',
    testimonialButtonLabel: appearance.testimonialButtonLabel ?? 'Try for Free',
    testimonialImage: appearance.testimonialImage ?? 'images/homepage/adds_img.png',

    cuttingEdgeHeading:
      appearance.cuttingEdgeHeading ??
      'Cutting-edge features adjusted to your business needs',
    cuttingEdgeImage: appearance.cuttingEdgeImage ?? 'images/homepage/cut_img.png',
    cuttingEdgeFeatures: toArray(appearance.cuttingEdgeFeatures).length
      ? toArray(appearance.cuttingEdgeFeatures)
      : defaultCuttingEdgeFeatures,

    advertisementHeading:
      appearance.advertisementHeading ??
      'Cutting-edge features adjusted to your business needs',
    advertisementSubtext:
      appearance.advertisementSubtext ??
      'Put your brand in front of your customers every time you share large files. Use branding to add your own logo, cover and personalized message',
    advertisementImage1:
      appearance.advertisementImage1 ?? 'images/homepage/advertise_img1.png',
    advertisementImage2:
      appearance.advertisementImage2 ?? 'images/homepage/advertise_img2.png',
  };
}
